// src/utils/fetchUserPermissions.js

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchUserPermissions = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/user-permissions`, {
      method: "GET",
      credentials: "include",
    });

    if (!response.ok) throw new Error("Failed to fetch permissions");

    const data = await response.json();

    return data.permissions;
  } catch (err) {
    console.error("Permission fetch failed:", err);
    return [];
  }
};